import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "passwordInput", "errorMessage"]
  static values = { siteId: Number }

  // The modal is a native <dialog>: showModal() puts it in the top layer, so no ancestor's
  // stacking context or overflow can clip it (the sites table's scroller does both).
  close(event) {
    event.stopPropagation()
    this.modalTarget.close()
    // Clear the password input and error message
    this.passwordInputTarget.value = ""
    this.errorMessageTarget.classList.add("hidden")
  }

  show(event) {
    // Prevent event bubbling
    event.stopPropagation()
    if (this.modalTarget.open) return
    this.modalTarget.showModal()
    // Clear previous error messages
    this.errorMessageTarget.classList.add("hidden")
  }

  async submit(event) {
    event.preventDefault()
    event.stopPropagation()

    const password = this.passwordInputTarget.value

    try {
      const response = await fetch(`/sites/${this.siteIdValue}/verify_password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        },
        body: JSON.stringify({ password: password }),
      })

      const data = await response.json()

      if (data.success) {
        window.location.href = `/sites/${this.siteIdValue}`
      } else {
        this.errorMessageTarget.textContent = data.error
        this.errorMessageTarget.classList.remove("hidden")
        this.passwordInputTarget.value = ""
        this.passwordInputTarget.focus()
      }
    } catch (error) {
      console.error("Error:", error)
      this.errorMessageTarget.textContent = "An error occurred. Please try again."
      this.errorMessageTarget.classList.remove("hidden")
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
